import { apiSlice } from "./apiSlice";
import { USER_PREFERENCES_URL } from "../../constants/urls";

export const userPreferencesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPreferredLanguage: builder.query({
      query: () => ({
        url: `${USER_PREFERENCES_URL}/preferred-language`,
        method: "GET",
      }),
      providesTags: ["PreferredLanguage"],
    }),
    updatePreferredLanguage: builder.mutation({
      query: (body) => ({
        url: `${USER_PREFERENCES_URL}/preferred-language`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["PreferredLanguage"],
    }),
  }),
});

export const {
  useGetPreferredLanguageQuery,
  useLazyGetPreferredLanguageQuery,
  useUpdatePreferredLanguageMutation,
} = userPreferencesApiSlice;
